export default {
    home_page_title: "Account Data",
    security_page_title: "Security Center",
    security_setting_page_title: "Security Center",
    security_phone_label: "Numéro de téléphone",
    security_email_label: "Adresse email",
    security_question_label: "Password questions",
    security_unset_text: "Non configuré",
    security_setted_text: "Configuré",
    security_question_options: [
        "What is your mother name?",
        "What is your partner name?",
        "What is your best friend name?",
        "What is your student number?",
        "Who is your favorite star?",
        "Who has affected you deepest?"
    ],
    password_lost_page_title: "Mot de passe oublié?",
    password_reset_page_title: "Réinitialiser le mot de passe",
    password_lost_account_placeholder:
        "Enter the account of which the password is forgotten",
    empty_lost_account_tips: "Username should not be empty",
    iscorrect_lost_account_tips: "Ce compte existe pas.",
    password_reset_new_placeholder: "Nouveau mot de passe",
    password_reset_confirm_placeholder: "Confirmer",
    password_verify_page_title: "Verify",
    phone_verify_page_title: "Verify",
    email_verify_page_title: "Verify",
    question_verify_page_title: "Verify",
    phone_reset_page_title: "Numéro de téléphone",
    email_reset_page_title: "Adresse email",
    question_reset_page_title: "Password questions",
    phone_binding_text: "Your bound cellphone number is",
    email_binding_text: "Your bound email address is",
    verification_code_text: "Code de confirmation",
    resend_text: "Renvoyer",
    empty_phone_number_tips: "Veuillez entrer le numéro de téléphone",
    iscorrect_phone_number_tips: "Veuillez saisir un bon numéro de téléphone.",
    empty_verification_code_tips: "Please input the verification code",
    iscorrect_verification_code_tips: "Erreur de code de confirmation",
    password_placeholder: "Mot de passe",
    empty_password_tips: "Mot de passe",
    iscorrect_password_tips: "Wrong password",
    mismatched_rule_password_tips:
        "Le mot de passe ne peut comprendre &, # ou Espace.",
    different_confirm_password_tips: "Mot de passe incohérent entré deux fois",
    empty_email_tips: "Please enter email address",
    iscorrect_email_tips: "Wrong email address",
    answer_placeholder: "Answer",
    empty_question_tips: "Question de sécurité",
    empty_answer_tips: "Réponse",
    iscorrect_answer_tips: "Votre réponse est fausse.",
    next_step_text: "Prochaine étape",
    submit_text: "Soumettre",
    submit_success_tips: "Établi avec succès",
    submit_error_tips:
        "Échec de l'opération, s'il vous plaît essayer à nouveau",
    get_data_fail_tips:
        "Échec de la connexion au réseau, veuillez réessayer dans un instant.",
    use_other_verification_type_text: "Verify in other means",
    custom_support_notice:
        "This account has not set any way to retrieve your password. Follow this link using a computer to apply:" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
